/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Select_Job_PlaceholderInputs */

const en_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const de_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const fr_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const es_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const it_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const nl_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const pl_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const fi_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const da_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

const sv_story_bank_select_job_placeholder = /** @type {(inputs: Story_Bank_Select_Job_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a job...`)
};

/**
* | output |
* | --- |
* | "Select a job..." |
*
* @param {Story_Bank_Select_Job_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_select_job_placeholder = /** @type {((inputs?: Story_Bank_Select_Job_PlaceholderInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Select_Job_PlaceholderInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_select_job_placeholder(inputs)
	if (locale === "fr") return fr_story_bank_select_job_placeholder(inputs)
	if (locale === "es") return es_story_bank_select_job_placeholder(inputs)
	if (locale === "it") return it_story_bank_select_job_placeholder(inputs)
	if (locale === "nl") return nl_story_bank_select_job_placeholder(inputs)
	if (locale === "pl") return pl_story_bank_select_job_placeholder(inputs)
	if (locale === "fi") return fi_story_bank_select_job_placeholder(inputs)
	if (locale === "da") return da_story_bank_select_job_placeholder(inputs)
	if (locale === "sv") return sv_story_bank_select_job_placeholder(inputs)
	return en_story_bank_select_job_placeholder(inputs)
});